// https://stackoverflow.com/a/15397495
const nth = function(d) {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1:  return "st";
    case 2:  return "nd";
    case 3:  return "rd";
    default: return "th";
  }
}

export default function(date) {
  if (date) {
    if (!date.getMonth) {
      date = new Date(`${date}T00:00:00.000Z`)
    }

    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][date.getMonth()];
    return `${date.getDate()}${nth(date.getDate())} ${month} ${date.getFullYear()}`
  }
}
